import script from "./Header.vue?vue&type=script&setup=true&lang=js"
export * from "./Header.vue?vue&type=script&setup=true&lang=js"

import "./Header.vue?vue&type=style&index=0&id=509a26bb&scoped=true&lang=scss"

import exportComponent from "F:\\hwx\\proj\\vscode\\twzc_system_web\\dataV\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-509a26bb"]])

export default __exports__